import { useState, useCallback, useEffect } from 'react';
import { TabType } from '../types/plan-overview-entity';

export const usePlanOverview = () => {
    const [selectedGoalIndex, setSelectedGoalIndex] = useState(0);
    const [selectedSecondaryTab, setSelectedSecondaryTab] = useState<TabType>(TabType.GoalOverview);
    const [goalsInEditMode, setGoalsInEditMode] = useState<Record<number, boolean>>({});

    useEffect(() => {
        setSelectedSecondaryTab(TabType.GoalOverview);
    }, [selectedGoalIndex]);

    const handleGoalChange = useCallback((_event: React.SyntheticEvent, newValue: number) => {
        setSelectedGoalIndex(newValue);
    }, []);

    const handleSecondaryTabChange = useCallback((_event: React.SyntheticEvent, newValue: number) => {
        setSelectedSecondaryTab(newValue);
    }, []);

    const handleEditPlan = useCallback((goalIndex: number) => {
        setGoalsInEditMode((prev) => ({ ...prev, [goalIndex]: true }));
    }, []);

    const handleExitEditPlan = useCallback((goalIndex: number) => {
        setGoalsInEditMode((prev) => {
            const updated = { ...prev };
            delete updated[goalIndex];
            return updated;
        });
    }, []);

    const isGoalInEditMode = useCallback((goalIndex: number) => Boolean(goalsInEditMode[goalIndex]), [goalsInEditMode]);

    return {
        selectedGoalIndex,
        selectedSecondaryTab,
        handleGoalChange,
        handleSecondaryTabChange,
        handleEditPlan,
        handleExitEditPlan,
        isGoalInEditMode
    };
};
